// extracted by mini-css-extract-plugin
export default {"Authorbooksmain":"AuthorAndIllustrator_Authorbooksmain__fcO6d"};